// extracted by mini-css-extract-plugin
module.exports = {"co-branding-banner":"_19ILK","coBrandingBanner":"_19ILK","top":"_1z14q","logo-wrapper":"_1bjjQ","logoWrapper":"_1bjjQ","rtl":"_1OMs6"};